import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'hex',
  standalone: false
})
export class HexPipe implements PipeTransform {
  transform(value: number): string {
    return '0x' + Number(value).toString(16).padStart(2, '0').toUpperCase();
  }
}
